<script setup lang="ts">
  import { useResizeObserver } from '@vueuse/core';
  import { computed } from 'vue';

  import { useFeatureEnrollmentProvider } from './FeatureEnrollmentLayout.vue';

  const { steps, activeStepIndex, activeSubstepIndex, contentRef } = useFeatureEnrollmentProvider();

  useResizeObserver(contentRef, () => {
    // Triggers the body component resize eventListener to recalculate the header animation
    window.dispatchEvent(new Event('resize'));
  });

  const activeComponent = computed(() => {
    const step = steps?.[activeStepIndex.value];
    const substep = step?.substeps?.[activeSubstepIndex.value];
    return substep?.component || step?.component;
  });
</script>

<template>
  <div class="tw-px-12 tw-py-6 lg:tw-px-[84px]" ref="contentRef">
    <component :is="{ ...activeComponent }" />
  </div>
</template>
